<div class="rg-page-header">
    <div>
        <h3 class="fw-bold mb-1">Admin Users</h3>
        <p class="text-muted mb-0">
            Manage RiskGuard Licensing admin accounts and access roles.
        </p>
    </div>

    <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary" (click)="loadUsers()" [disabled]="loading">
            <i class="bi bi-arrow-clockwise me-1"></i>
            Refresh
        </button>

        <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createAdminUserModal">
            <i class="bi bi-plus-lg me-1"></i>
            New Admin
        </button>
    </div>
</div>

<div class="container-fluid p-4">
    <div class="card border-0 shadow-sm rg-card">
        <div class="card-body">
            <div class="table-responsive">
                <table class="table align-middle mb-0">
                    <thead>
                        <tr>
                            <th>Admin</th>
                            <th>Role</th>
                            <th>Status</th>
                            <th>Created</th>
                            <th class="text-end">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngIf="!loading && users.length === 0">
                            <td colspan="5" class="text-center py-4 text-muted">
                                No record found.
                            </td>
                        </tr>

                        <tr *ngFor="let user of users">
                            <td>
                                <div class="fw-semibold">{{ user.fullName }}</div>
                                <small class="text-muted">{{ user.email }}</small>
                            </td>

                            <td>
                                {{ getRoleLabel(user.role) }}
                            </td>

                            <td>
                                <span class="badge" [ngClass]="getStatusClass(user.status)">
                                    {{ getStatusLabel(user.status) }}
                                </span>
                            </td>

                            <td>
                                {{ user.createdAt | date:'mediumDate' }}
                            </td>

                            <td class="text-end">
                                <button class="btn btn-sm btn-outline-primary me-1" (click)="openRoleModal(user)">
                                    Change Role
                                </button>

                                <div class="btn-group">
                                    <button class="btn btn-sm btn-outline-dark dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                        More
                                    </button>

                                    <ul class="dropdown-menu dropdown-menu-end">
                                        <li>
                                            <button class="dropdown-item" (click)="changeStatus(user, 'activate')">
                                                Activate
                                            </button>
                                        </li>

                                        <li>
                                            <button class="dropdown-item text-danger"
                                                (click)="changeStatus(user, 'disable')">
                                                Disable
                                            </button>
                                        </li>
                                        <li>
                                            <button class="dropdown-item" (click)="openResetPasswordModal(user)">
                                                Reset Password
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="changeAdminRoleModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rg-modal">
            <div class="modal-header">
                <h5 class="modal-title fw-bold">Change Admin Role</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form (ngSubmit)="changeRole()">
                <div class="modal-body">
                    <div class="alert alert-light border" *ngIf="selectedUser">
                        <small class="text-muted">Admin User</small>
                        <div class="fw-semibold">{{ selectedUser.fullName }}</div>
                        <small class="text-muted">{{ selectedUser.email }}</small>
                    </div>

                    <label class="form-label">Role</label>
                    <select class="form-select" name="role" [(ngModel)]="roleModel.role">
                        <option [ngValue]="1">SuperAdmin</option>
                        <option [ngValue]="2">Admin</option>
                        <option [ngValue]="3">Support</option>
                    </select>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary" [disabled]="updatingRole">
                        <span *ngIf="!updatingRole">Save Role</span>
                        <span *ngIf="updatingRole">Saving...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal fade" id="createAdminUserModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rg-modal">
            <div class="modal-header">
                <h5 class="modal-title fw-bold">Create Admin User</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form (ngSubmit)="createAdmin()">
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label">Full Name</label>
                        <input type="text" class="form-control" name="adminFullName" [(ngModel)]="createModel.fullName">
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Email</label>
                        <input type="email" class="form-control" name="adminEmail" [(ngModel)]="createModel.email">
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Temporary Password</label>
                        <input type="password" class="form-control" name="adminPassword"
                            [(ngModel)]="createModel.password">
                    </div>

                    <div>
                        <label class="form-label">Role</label>
                        <select class="form-select" name="adminRole" [(ngModel)]="createModel.role">
                            <option [ngValue]="1">SuperAdmin</option>
                            <option [ngValue]="2">Admin</option>
                            <option [ngValue]="3">Support</option>
                        </select>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary" [disabled]="creating">
                        <span *ngIf="!creating">Create Admin</span>
                        <span *ngIf="creating">Creating...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal fade" id="resetAdminPasswordModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rg-modal">
      <div class="modal-header">
        <h5 class="modal-title fw-bold">Reset Admin Password</h5>
        <button type="button" class="btn-close" (click)="closeResetPasswordModal()"></button>
      </div>

      <form (ngSubmit)="resetPassword()">
        <div class="modal-body">
          <div class="alert alert-light border" *ngIf="selectedUser">
            <small class="text-muted">Admin User</small>
            <div class="fw-semibold">{{ selectedUser.fullName }}</div>
            <small class="text-muted">{{ selectedUser.email }}</small>
          </div>

          <div *ngIf="!lastResetPassword">
            <div class="mb-3">
              <label class="form-label">New Temporary Password</label>
              <input
                type="text"
                class="form-control"
                name="resetNewPassword"
                [(ngModel)]="resetPasswordModel.newPassword">
            </div>

            <div>
              <label class="form-label">Confirm Password</label>
              <input
                type="text"
                class="form-control"
                name="resetConfirmPassword"
                [(ngModel)]="resetPasswordModel.confirmPassword">
            </div>
          </div>

          <div *ngIf="lastResetPassword" class="alert alert-success">
            <strong>Password reset successfully.</strong>

            <div class="mt-3">
              <label class="form-label">Temporary Password</label>
              <div class="input-group">
                <input class="form-control" [value]="lastResetPassword" readonly>
                <button class="btn btn-outline-secondary" type="button" (click)="copyResetPassword()">
                  Copy
                </button>
              </div>
            </div>

            <small class="d-block mt-2">
              Share this password through your approved internal channel.
            </small>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="closeResetPasswordModal()">
            Close
          </button>

          <button
            *ngIf="!lastResetPassword"
            type="submit"
            class="btn btn-primary"
            [disabled]="resettingPassword">
            <span *ngIf="!resettingPassword">Reset Password</span>
            <span *ngIf="resettingPassword">Resetting...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
